import 'jquery';
import "@babel/polyfill";
import 'filepond-polyfill';
import * as FilePond from 'filepond';
import { standardAjaxPost } from 'stdjs/standard-ajax';
import { displayMessages } from 'stdjs/validation';
import Translator from "./translate-service";
import { get } from 'jquery';

export function setupFilePond(createFrom, displayImage, formField, saveUrl, cropType = null, options = {}, uploadCompleteCallback = function(data){} ){

    if ( typeof ( options[ "displayPreview" ] ) === "undefined" ){
        options[ "displayPreview" ] = true;
    }
    if ( typeof ( options[ "removeFilesAfterUpload" ] ) === "undefined" ){
        options[ "removeFilesAfterUpload" ] = true;
    }
 
    if ( typeof ( options[ "updateFormField" ] ) === "undefined" ){
        options[ "updateFormField" ] = true;
    }
    
    var pond = FilePond.create(createFrom.get(0), {
        maxFiles: 1,
        allowMultiple: false,
        labelIdle: Translator.tr( 'Drag & Drop your file <strong>onto this box</strong> or <span class="filepond--label-action"> click here to Browse </span>' ),
        server: {
            process: function(fieldName, file, metadata, load, error, progress, abort) {
 
                
                var successCallback = function(data){
                    if ( displayImage && options[ "displayPreview" ] ){
                        displayImage.attr("src", data.filePath);
                    }

                    if (options[ "updateFormField" ]) {
                        formField.val(data.fileUpload.UPLD10_ID);
                    }
                    load(); // removed this because it just flashed then disappeared
                    if ( displayImage && options[ "removeFilesAfterUpload" ] ){
                        pond.removeFiles();
                    }      
                    
                    uploadCompleteCallback(data);
                };
                var errorCallback = function(data){
                    error();                    
                };
                processFileUpload( saveUrl, file, successCallback, errorCallback, cropType );                                                                                        
            }
        }
    });
 
}

export function processFileUpload( saveUrl, file, successCallback, errorCallback = null, cropType = null, ){
        
    if ($("#UPLD10").length === 0){
        var data = new FormData();
        data.append("UPLD10_OWTY", $("#UPLD10_OWTY").val());
        data.append("UPLD10_OWID", $("#UPLD10_OWID").val());
    } else {
        var data = new FormData($("#UPLD10").get(0));
    }
    data.append("UPLD10_UPLD", file, file.name);
    if (cropType !== null){
        data.append("CROP_TYPE", cropType);
    }

    var processSuccessCallback = function(data){
        successCallback(data);
    };

    var processErrorCallback = function(data){
        displayMessages(data.errorMessages, data.warningMessages, data.infoMessages);
        if ( errorCallback != null ){
            errorCallback(data);
        }
    };

    standardAjaxPost(saveUrl, data, processSuccessCallback, processErrorCallback);
    //////

}

export function clearFilePondFiles( $element ){
    var filePond = FilePond.find( $element.get(0) );
    if (filePond != null) {
    //this will remove all files
        filePond.removeFiles();
    }
}